<template>
    <div class="making-our-brand-tangible-design-system" :data-shape-id="shapeId" ref="sectionWrapper">
        <div class="wrapper wrapper-medium">
            <div class="section-copy">
                <div class="overline">Making Our Brand Tangible</div>
                <h2 class="major-heading">Design<br />System</h2>
                <p>
                    With our design system Scale you can create brand-compliant interfaces more easily. It provides
                    production-ready components in code and design, a centrally accessible library and comprehensive
                    documentation.
                </p>
                <div class="container-cta">
                    <p class="copy">
                        Explore all elements <br />and resources on:<br />
                        <span class="fw-bold">
                            <a target="_blank" href="https://github.com/telekom/scale">github.com/telekom/scale</a>
                        </span>
                    </p>
                </div>
            </div>
            <div class="section-visual">
                <img src="../../../assets/svg/design-system/visual.svg" alt="The Telekom Brand and Design Portal" />
            </div>
        </div>
    </div>
</template>

<script>
    // import ButtonIcon from '../../patterns/buttons/ButtonIcon.vue';

    export default {
        name: 'MakingOurBrandTangibleDesignSystem',
    };
</script>

<style scoped lang="scss">
    .making-our-brand-tangible-design-system {
        &.active {
            .section-copy {
                animation: anim-fade-in 1s 0.7s forwards;
            }

            .section-visual {
                animation: anim-fade-in-from-bottom 1s 0.9s forwards;
            }
        }

        &.on-leave {
            .section-copy,
            .button-container {
                animation: anim-fade-out 0.3s forwards;
            }
        }
        .wrapper {
            @include flex($align-items: center);

            @media (max-width: breakpoint('medium')) {
                // @include flex($flex-direction: column-reverse);
            }
        }

        .section-visual,
        .section-copy {
            opacity: 0;
            width: 50%;

            @media (max-width: breakpoint('medium')) {
                width: 100%;
            }
        }

        .section-visual {
            @media (max-width: breakpoint('medium')) {
                margin-top: spacing(10);
            }

            @media (max-width: breakpoint('small')) {
                display: none;
            }

            img {
                @include reset-img();
                width: 120%;
                margin-left: 20px;
                @media (max-width: breakpoint('medium')) {
                    margin: 0 auto;
                    height: 15vh;
                    width: auto;
                }
                //box-shadow: 10px 45px 55px 0px rgba(0, 0, 0, 0.35);
            }
        }

        .container-cta {
            position: relative;
            margin-top: spacing(5);
            display: inline-block;

            .copy {
                padding-right: 75px;
                @include border-box();

                @media (min-width: breakpoint('small') + 1) {
                    br:first-of-type {
                        display: none;
                    }
                }

                @media (max-width: breakpoint('small')) {
                    padding-right: 0;
                }
            }

            .container-button {
                position: absolute;
                right: -#{spacing(5)};
                top: 50%;
                width: 60px;
                height: 60px;
                transform: translateY(-50%);

                @media (max-width: breakpoint('small')) {
                    position: initial;
                    transform: none;
                    margin: spacing(3) auto 0 auto;
                }
            }
        }

        p {
            line-height: 1.3em;
        }

        @media (max-width: breakpoint('medium')) {
            text-align: center;
        }
    }
</style>
